function convertToSuitableUnit(sizeInBytes) {
  if (sizeInBytes / 1024 < 1024) {
    return Math.round(sizeInBytes / 1024) + " KB";
  } else if (sizeInBytes / 1024 / 1024 < 1024) {
    return (sizeInBytes / 1024 / 1024).toFixed(2) + " MB";
  }
}

export default convertToSuitableUnit;
